import React from "react"
import {
  SolidButton,
  LinkButton,
  TextButton,
  OutlinedButton,
  UnderlinedButton,
  QuantityButton,
} from "./Buttons"

export const Button = ( {
  children,
  variant = "solid",
  to,
  onClick,
  action,
  reloader,
  disabled,
  item,
  color,
  hover = '',
  size = "normal",
  leftIcon = "",
  rightIcon = "",
  type = "",
} ) => {
  switch ( variant ) {
    case "link":
      return ( <LinkButton to={ to } leftIcon={ leftIcon } rightIcon={ rightIcon } onClick={ onClick }>{ children }</LinkButton> )
    case "text":
      return ( <TextButton size={ size } hover={ hover } type={ type } onClick={ onClick } leftIcon={ leftIcon } rightIcon={ rightIcon }>{ children }</TextButton> )
    case "outlined":
      return ( <OutlinedButton type={ type } onClick={ onClick } leftIcon={ leftIcon } rightIcon={ rightIcon }>{ children }</OutlinedButton> )
    case "underlined":
      return ( <UnderlinedButton type={ type } onClick={ onClick } leftIcon={ leftIcon } rightIcon={ rightIcon }>{ children }</UnderlinedButton> )
    case "quantity":
      return ( <QuantityButton reloader={ reloader } actionText={ children } action={ action } item={ item } color={ color } /> )
    default:
      return ( <SolidButton size={ size } type={ type } disabled={ disabled } onClick={ onClick } leftIcon={ leftIcon } rightIcon={ rightIcon }>{ children }</SolidButton> )
  }
}

export default Button